module.exports = __webpack_public_path__ + "img/Penrose-Gaming-Logo-White-01.9696dc25.png";